import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { ContactDetails } from '@repo/types';
import { useGlobalContext } from '@slc/tools/GlobalContext';

// 30 minutes frontend cache for contact details query
const CACHE_TIME = 30 * 60 * 1000;

export const useContactDetailsQuery = () => {
  const { apiUrl } = useGlobalContext();

  return useQuery({
    queryKey: ['contactDetails', apiUrl],
    queryFn: () => fetchContactDetails(apiUrl),
    staleTime: CACHE_TIME,
    enabled: !!apiUrl,
  });
};

const fetchContactDetails = async (apiUrl: string): Promise<ContactDetails | null> => {
  const { data } = await axios.get<ContactDetails | null>(`${apiUrl}${API.endpoints.contactDetailsSettings}`);
  return data;
};
